import React from "react";
import "./PortalLoader.css";

/** css-loader-101 / loader-circle-11 — three 3D rotating arcs */
function ArcSpinner({ size = "md" }) {
  const sizeClass =
    size === "sm" ? "portal-loader-arc--sm" : size === "lg" ? "portal-loader-arc--lg" : "";
  return (
    <div className={`portal-loader-arc ${sizeClass}`} aria-hidden="true">
      <div className="portal-loader-arc__ring" />
      <div className="portal-loader-arc__ring" />
      <div className="portal-loader-arc__ring" />
    </div>
  );
}

export default function PortalLoader({
  message = "Loading",
  submessage = "",
  variant = "section",
  size = "md",
  className = "",
  live = true,
}) {
  const rootClass = [
    "portal-loader",
    variant === "page" ? "portal-loader--page" : "",
    variant === "section" ? "portal-loader--section" : "",
    variant === "inline" ? "portal-loader--inline" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const arcSize = variant === "inline" ? "sm" : size === "lg" ? "lg" : "md";

  return (
    <div className={rootClass} role="status" aria-live={live ? "polite" : "off"} aria-busy="true">
      <ArcSpinner size={arcSize} />
      <div>
        <p className="portal-loader-message">{message}</p>
        {submessage ? <p className="portal-loader-sub">{submessage}</p> : null}
      </div>
    </div>
  );
}

export function PortalPageFallback({ message = "Loading page", submessage = "", className = "" }) {
  return <PortalLoader variant="page" size="lg" message={message} submessage={submessage} className={className} />;
}

export function PortalSectionFallback({ message = "Loading", submessage = "", className = "" }) {
  return <PortalLoader variant="section" message={message} submessage={submessage} className={className} />;
}

export function PortalOverlayLoader({ message = "Working", submessage = "" }) {
  return (
    <div className="portal-loader-overlay" role="presentation">
      <PortalLoader variant="section" size="lg" message={message} submessage={submessage} live={false} />
    </div>
  );
}
